<template>
  <div class="scenario_inputs">
    <div
        v-for="item in childAge"
        class="col-xs-12 form-group from_main">
      <div class="scenario_input">
        <input
            type="number"
            class="flex_box heigh-45"
            v-model.number.lazy="item.value"
            @change="inputOne"
            :placeholder="item.label">
        <label data-domain="歲"></label>
      </div>
    </div>
    <div v-if="errMessages" class="error_text">{{ errMessages }}</div>
    <div v-if="isEmpty" class="error_text">{{ survey.warning }}</div>
  </div>
</template>

<script>
import {dispatch, get} from "vuex-pathify";

export default {
  name: "multiple_input",
  props: {
    page_no: Number,
    options: Array,
    survey: Object,
  },
  data() {
    return {
      valueSelected: 1,
      childAge: [],
      moduleName: '',
      errMessages: null,
    }
  },
  methods: {
    inputOne() {
      let ageArr = []
      try {
        this.childAge.forEach(item => {
          if (typeof (item.value) !== "number" && item.value !== "") {
            item.value = null
            throw "請輸入正整數"
          }
          if (!(item.value >= 0) || !(item.value <= 18)) {
            item.value = null
            throw "年齡區間為 0 到 18 歲之間"
          }
          ageArr.push(item.value)
        })
        dispatch(this.moduleName + '/setPostData', {page_no: this.page_no, page_answer: ageArr})
      } catch (e) {
        this.errMessages = e
      }
    },
  },
  created() {
    this.moduleName = store.get('moduleName')
    this.inputOne()
    this.childAge = this.options.filter((value, key) => key < store.get(`${this.moduleName}/postData`)[1])
  },
  computed: {
    ...get('educationFund', {
      isEmpty: 'isEmpty',
    }),
  },
}
</script>

<style scoped>
.error_text{
  color: red;
  padding-left: 15px;
}
.from_main label::after {
    content: " " attr(data-domain);
    position: absolute;
    top: -32px;
    right: 10px;
    display: block;
    color: #565656;
}
</style>